import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import InputCausaDelPago from 'components/blocks/ManagementNewForms/Inputs/FormInputCasuaDelPago';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import { useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreateSolicitudPagoDirecto from 'services/record/SolicitudPagoDirecto/useCreateSolicitudPagoDirecto';
import useUpdateSolicitudPagoDirectoByID from 'services/record/SolicitudPagoDirecto/useUpdateSolicitudPagoDirecto';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';

const SolicitudPagoDirecto = ({ info, dataUser, onSuccess: _onSuccess }: { info: boolean; dataUser: any; onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { handleSubmit, reset, setValue, watch, register, clearErrors, formState: { errors } } = formMethods;
    const { createSolicitudPagoDirecto, errorCreateSolicitudPagoDirecto, loadingCreateSolicitudPagoDirecto, successCreateSolicitudPagoDirecto } = useCreateSolicitudPagoDirecto();
    const { updateSolicitudPagoDirectoById, errorUpdateSolicitudPagoDirectoById, loadingUpdateSolicitudPagoDirectoById, successUpdateSolicitudPagoDirectoById } = useUpdateSolicitudPagoDirectoByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const [entornosLaborales, setEntornosLaborales] = useState<any[]>([]);
    const [selectedEntornoLaboralId, setSelectedEntornoLaboralId] = useState<string | null>(null);
    const [selectedEntornoEsAutonomo, setSelectedEntornoEsAutonomo] = useState<boolean | null>(null);
    const contingenciaCodigo = watch('CausaPagoDirecto.ContingenciaCodigo');
    void _onSuccess;
    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;
    const getValue = (...values: any[]) => values.find(value => value !== undefined && value !== null);

    const clearCausaPagoValues = useCallback(() => {
        setValue('CausaPagoDirecto.CausaPago', null);
        setValue('CausaPagoDirecto.CausaPagoDescripcion', null);
        clearErrors('CausaPagoDirecto.CausaPagoDescripcion');
    }, [setValue, clearErrors]);

    const getEntornoOptionValue = (entorno: any, index: number) => {
        return String(getValue(entorno?.EntornoLaboralId, entorno?.EntornoLaboralEmpresaId, index));
    };

    const getDocumentacionByEntorno = (entorno: any, data: any) => {
        const rawDocumentacion = getValue(
            entorno?.SeccionesDocumentacion,
            entorno?.seccionesDocumentacion,
            entorno?.Documentacion,
            entorno?.documentacion,
            data?.SeccionesDocumentacion,
            data?.seccionesDocumentacion,
            data?.Documentacion,
            data?.documentacion,
            []
        );

        if (!Array.isArray(rawDocumentacion) || rawDocumentacion.length === 0) {
            return [];
        }

        return rawDocumentacion;
    };

    const setEntornoLaboralValues = (entorno: any, data: any) => {
        if (!entorno) {
            return;
        }

        const esAutonomo = getValue(entorno?.EsAutonomo, entorno?.esAutonomo, null);

        setSelectedEntornoEsAutonomo(esAutonomo === null ? null : Boolean(esAutonomo));
        setValue('EntornoLaboral.PrestacionRazonSocial', getValue(entorno?.RazonSocial, entorno?.PrestacionRazonSocial, entorno?.Nombre, data?.RazonSocial, data?.razonSocial, null));
        setValue('EntornoLaboral.PrestacionCCC', getValue(entorno?.CCC, entorno?.PrestacionCCC, data?.CCC, data?.ccc, null));
        setValue('EntornoLaboral.PrestacionNAF', getValue(entorno?.NAF, entorno?.PrestacionNAF, data?.NAF, data?.naf, null));
        setValue('EntornoLaboral.PrestacionCIF', getValue(entorno?.CIF, entorno?.PrestacionCIF, data?.CIF, data?.cif, null));
        setValue('EntornoLaboral.TipoContrato', getValue(entorno?.CodigoTipoContrato, entorno?.TipoContrato, entorno?.tipoContrato, data?.TipoContratoCodigo, data?.tipoContratoCodigo, data?.CodigoTipoContrato, data?.codigoTipoContrato, null));
        setValue('EntornoLaboral.TipoContratoDescripcion', getValue(entorno?.TipoContratoDescripcion, entorno?.tipoContratoDescripcion, data?.TipoContratoDescripcion, data?.tipoContratoDescripcion, null));
        setValue('EntornoLaboral.RegimenSeguridadSocial', getValue(entorno?.CodigoRegimenSeguridadSocial, entorno?.RegimenSeguridadSocial, entorno?.regimenSeguridadSocial, data?.RegimenSeguridadSocialCodigo, data?.regimenSeguridadSocialCodigo, data?.CodigoRegimenSeguridadSocial, data?.codigoRegimenSeguridadSocial, null));
        setValue('EntornoLaboral.RegimenSeguridadSocialDescripcion', getValue(entorno?.RegimenSeguridadSocialDescripcion, entorno?.regimenSeguridadSocialDescripcion, data?.RegimenSeguridadSocialDescripcion, data?.regimenSeguridadSocialDescripcion, null));
        setValue('DatosPersonales.IRPFVoluntario', getValue(entorno?.TipoIRPFVoluntario, entorno?.IRPFVoluntario, data?.TipoIRPFVoluntario, data?.tipoIRPFVoluntario, data?.PorcentajeIRPFVoluntario, data?.porcentajeIRPFVoluntario, null));

        const documentacionEntorno = getDocumentacionByEntorno(entorno, data);
        setValue('Documentacion', adaptDocumentacion(documentacionEntorno));
        setTotalSize(0);
    };

    const handleEntornoLaboralChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        setSelectedEntornoLaboralId(selectedValue && selectedValue.trim() !== "" ? selectedValue : null);
        setValue('EntornoLaboral.EntornoLaboralId', selectedValue && selectedValue.trim() !== "" ? selectedValue : null, { shouldValidate: true, shouldDirty: true });
    };



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {
            const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
            const entornos = getValue(data?.EntornosLaborales, data?.entornosLaborales, []);
            const datosPersonales = getValue(data?.DatosPersonales, data?.datosPersonales) || {};
            const entornoLaboral = getValue(data?.EntornoLaboral, data?.entornoLaboral) || {};
            const causaPagoDirecto = getValue(data?.CausaPagoDirecto, data?.causaPagoDirecto) || {};
            const datosBancarios = getValue(data?.DatosBancarios, data?.datosBancarios) || {};

            const hasFlatEntornoData = getValue(
                data?.EntornoLaboralId,
                data?.entornoLaboralId,
                data?.RazonSocial,
                data?.razonSocial,
                data?.EsAutonomo,
                data?.esAutonomo,
                data?.CodigoRegimenSeguridadSocial,
                data?.codigoRegimenSeguridadSocial,
                null
            ) !== null;

            const entornoFlatWhenUpdate = !info && hasFlatEntornoData
                ? {
                    EntornoLaboralId: getValue(data?.EntornoLaboralId, data?.entornoLaboralId, null),
                    RazonSocial: getValue(data?.RazonSocial, data?.razonSocial, null),
                    CCC: getValue(data?.CCC, data?.ccc, null),
                    NAF: getValue(data?.NAF, data?.naf, null),
                    CIF: getValue(data?.CIF, data?.cif, null),
                    CodigoTipoContrato: getValue(data?.CodigoTipoContrato, data?.codigoTipoContrato, null),
                    TipoContratoDescripcion: getValue(data?.TipoContratoDescripcion, data?.tipoContratoDescripcion, null),
                    EsAutonomo: getValue(data?.EsAutonomo, data?.esAutonomo, null),
                    CodigoRegimenSeguridadSocial: getValue(data?.CodigoRegimenSeguridadSocial, data?.codigoRegimenSeguridadSocial, null),
                    RegimenSeguridadSocialDescripcion: getValue(data?.RegimenSeguridadSocialDescripcion, data?.regimenSeguridadSocialDescripcion, null),
                    TipoIRPFVoluntario: getValue(
                        data?.TipoIRPFVoluntario,
                        data?.tipoIRPFVoluntario,
                        data?.PorcentajeIRPFVoluntario,
                        data?.porcentajeIRPFVoluntario,
                        null
                    ),
                    SeccionesDocumentacion: getValue(
                        data?.SeccionesDocumentacion,
                        data?.seccionesDocumentacion,
                        data?.Documentacion,
                        data?.documentacion,
                        []
                    ),
                }
                : null;

            const entornosList = Array.isArray(entornos) && entornos.length > 0
                ? entornos
                : (entornoFlatWhenUpdate ? [entornoFlatWhenUpdate] : []);
            setEntornosLaborales(entornosList);

            const entornoIdFromData = getValue(
                data?.EntornoLaboralId,
                data?.entornoLaboralId,
                entornoLaboral?.EntornoLaboralId,
                entornoLaboral?.entornoLaboralId,
                null
            );

            const selectedId = entornosList.length > 0
                ? getValue(
                    selectedEntornoLaboralId,
                    entornoIdFromData !== null && entornoIdFromData !== undefined ? String(entornoIdFromData) : null,
                    entornosList.length === 1 ? getEntornoOptionValue(entornosList[0], 0) : null,
                    null
                )
                : null;

            const selectedIdInList = entornosList.find((item, index) => getEntornoOptionValue(item, index) === selectedId);

            const entornoPreseleccionado = selectedIdInList
                ? selectedIdInList
                : (entornosList.length === 1 ? entornosList[0] : entornoLaboral);

            const esAutonomoPreseleccionado = getValue(
                entornoPreseleccionado?.EsAutonomo,
                entornoPreseleccionado?.esAutonomo,
                data?.EsAutonomo,
                data?.esAutonomo,
                null
            );
            setSelectedEntornoEsAutonomo(esAutonomoPreseleccionado === null ? null : Boolean(esAutonomoPreseleccionado));

            if (entornosList.length === 1) {
                const onlyEntornoId = getEntornoOptionValue(entornosList[0], 0);
                setSelectedEntornoLaboralId(onlyEntornoId);
                setValue('EntornoLaboral.EntornoLaboralId', onlyEntornoId);
            } else if (entornosList.length > 1) {
                const selectedForMulti = selectedIdInList ? selectedId : null;
                setSelectedEntornoLaboralId(selectedForMulti);
                setValue('EntornoLaboral.EntornoLaboralId', selectedForMulti, { shouldValidate: true });
            } else if (entornosList.length === 0) {
                setSelectedEntornoLaboralId(null);
                setValue('EntornoLaboral.EntornoLaboralId', null);
            }

            const contingenciaCodigo = getValue(causaPagoDirecto?.ContingenciaCodigo, causaPagoDirecto?.contingenciaCodigo, data?.ContingenciaCodigo, data?.contingenciaCodigo, data?.CodigoContingencia, data?.codigoContingencia);
            const causaPago = getValue(
                causaPagoDirecto?.CausaPago,
                causaPagoDirecto?.causaPago,
                data?.CausaPagoDirecto,
                data?.causaPagoDirectoCodigo,
                data?.CodigoCausaPagoDirecto,
                data?.codigoCausaPagoDirecto
            );
            const rawIban = getValue(
                datosBancarios?.SolicitanteIBAN,
                datosBancarios?.solicitanteIBAN,
                data?.NumeroCuentaConIBAN,
                data?.numeroCuentaConIBAN,
                data?.IBAN,
                data?.iban,
                ""
            );
            const documentacionEntorno = getDocumentacionByEntorno(entornoPreseleccionado, data);

            reset({
                DatosPersonales: {
                    SolicitanteNombre: getValue(datosPersonales?.Nombre, datosPersonales?.nombre, null),
                    SolicitanteApellido1: getValue(datosPersonales?.Apellido1, datosPersonales?.apellido1, null),
                    SolicitanteApellido2: getValue(datosPersonales?.Apellido2, datosPersonales?.apellido2, null),
                    SolicitanteIPF: getValue(datosPersonales?.IPF, datosPersonales?.ipf, null),
                    SolicitanteIPFTipo: getValue(datosPersonales?.IPFTipo, datosPersonales?.ipfTipo)?.toString() || "1",

                    SolicitanteTelefono: getValue(datosPersonales?.Telefono, datosPersonales?.telefono, null),
                    SolicitanteFijo: getValue(datosPersonales?.Fijo, datosPersonales?.fijo, null),
                    SolicitanteDomicilio: getValue(datosPersonales?.Domicilio, datosPersonales?.domicilio, null),
                    SolicitanteCodigoPostal: getValue(datosPersonales?.CodigoPostal, datosPersonales?.codigoPostal, null),
                    SolicitanteProvincia: getValue(datosPersonales?.CodigoProvincia, datosPersonales?.codigoProvincia, null),
                    SolicitanteProvinciaDescripcion: getValue(datosPersonales?.Provincia, datosPersonales?.ProvinciaDescripcion, datosPersonales?.provinciaDescripcion, null),
                    SolicitanteComunidadCodigo: getValue(datosPersonales?.ComunidadCodigo, datosPersonales?.CodigoLocalidad, datosPersonales?.codigoLocalidad, null),
                    SolicitanteComunidadCodigoDescripcion: getValue(datosPersonales?.ComunidadCodigoDescripcion, datosPersonales?.LocalidadDescripcion, datosPersonales?.localidadDescripcion, null),
                    SolicitanteEmail: getValue(data?.Email, data?.email, null),
                    SolicitanteFechaNacimiento: getValue(data?.FechaNacimiento, data?.fechaNacimiento, null),
                    SolicitanteNumeroSS: getValue(datosPersonales?.NumeroSeguridadSocial, datosPersonales?.numeroSeguridadSocial, null),
                    SolicitanteIRPF: getValue(data?.TipoIRPFVoluntario, data?.tipoIRPFVoluntario, null),
                    IRPFVoluntario: getValue(
                        entornoPreseleccionado?.TipoIRPFVoluntario,
                        entornoPreseleccionado?.IRPFVoluntario,
                        datosPersonales?.IRPFVoluntario,
                        datosPersonales?.irpfVoluntario,
                        data?.TipoIRPFVoluntario,
                        data?.tipoIRPFVoluntario,
                        data?.PorcentajeIRPFVoluntario,
                        data?.porcentajeIRPFVoluntario,
                        null
                    ),
                },
                EntornoLaboral: {
                    PrestacionRazonSocial: getValue(entornoPreseleccionado?.RazonSocial, entornoPreseleccionado?.PrestacionRazonSocial, entornoPreseleccionado?.Nombre, entornoLaboral?.PrestacionRazonSocial, entornoLaboral?.prestacionRazonSocial, data?.RazonSocial, data?.razonSocial, null),
                    PrestacionCCC: getValue(entornoPreseleccionado?.CCC, entornoPreseleccionado?.PrestacionCCC, entornoLaboral?.PrestacionCCC, entornoLaboral?.prestacionCCC, data?.CCC, data?.ccc, null),
                    PrestacionNAF: getValue(entornoPreseleccionado?.NAF, entornoPreseleccionado?.PrestacionNAF, entornoLaboral?.PrestacionNAF, entornoLaboral?.prestacionNAF, data?.NAF, data?.naf, null),
                    PrestacionCIF: getValue(entornoPreseleccionado?.CIF, entornoPreseleccionado?.PrestacionCIF, entornoLaboral?.PrestacionCIF, entornoLaboral?.prestacionCIF, data?.CIF, data?.cif, null),
                    TipoContrato: getValue(entornoPreseleccionado?.CodigoTipoContrato, entornoPreseleccionado?.TipoContrato, entornoPreseleccionado?.tipoContrato, entornoLaboral?.TipoContrato, entornoLaboral?.tipoContrato, data?.TipoContratoCodigo, data?.tipoContratoCodigo, null),
                    TipoContratoDescripcion: getValue(entornoPreseleccionado?.TipoContratoDescripcion, entornoPreseleccionado?.tipoContratoDescripcion, entornoLaboral?.TipoContratoDescripcion, entornoLaboral?.tipoContratoDescripcion, data?.TipoContratoDescripcion, data?.tipoContratoDescripcion, null),
                    RegimenSeguridadSocial: getValue(entornoPreseleccionado?.CodigoRegimenSeguridadSocial, entornoPreseleccionado?.RegimenSeguridadSocial, entornoPreseleccionado?.regimenSeguridadSocial, entornoLaboral?.RegimenSeguridadSocial, entornoLaboral?.regimenSeguridadSocial, data?.RegimenSeguridadSocialCodigo, data?.regimenSeguridadSocialCodigo, null),
                    RegimenSeguridadSocialDescripcion: getValue(entornoPreseleccionado?.RegimenSeguridadSocialDescripcion, entornoPreseleccionado?.regimenSeguridadSocialDescripcion, entornoLaboral?.RegimenSeguridadSocialDescripcion, entornoLaboral?.regimenSeguridadSocialDescripcion, data?.RegimenSeguridadSocialDescripcion, data?.regimenSeguridadSocialDescripcion, null),
                },
                CausaPagoDirecto: {
                    PrestacionFechaBajaMedica: getValue(causaPagoDirecto?.PrestacionFechaBajaMedica, causaPagoDirecto?.prestacionFechaBajaMedica, data?.FechaBajaMedica, data?.fechaBajaMedica, null),
                    ContingenciaCodigo: contingenciaCodigo === -1 || contingenciaCodigo === "-1" ? null : (contingenciaCodigo || null),
                    ContingenciaCodigoDescripcion: getValue(causaPagoDirecto?.ContingenciaCodigoDescripcion, causaPagoDirecto?.contingenciaCodigoDescripcion, data?.ContingenciaCodigoDescripcion, data?.contingenciaCodigoDescripcion, data?.ContingenciaDescripcion, data?.contingenciaDescripcion, null),
                    CausaPago: causaPago === -1 || causaPago === "-1" ? null : (causaPago || null),
                    CausaPagoDescripcion: getValue(causaPagoDirecto?.CausaPagoDescripcion, causaPagoDirecto?.causaPagoDescripcion, data?.CausaPagoDirectoDescripcion, data?.causaPagoDirectoDescripcion, null),
                },
                DatosBancarios: {
                    SolicitanteIBAN: data?.IBAN ? data?.IBAN.replace(/-/g, '') : "",
                },
                Documentacion: adaptDocumentacion(documentacionEntorno)
            })
        }

    }

    useEffect(() => {
        setDatosAPI(dataUser);
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);

    useEffect(() => {
        if (entornosLaborales.length <= 1 || !selectedEntornoLaboralId) {
            return;
        }

        const entornoSeleccionado = entornosLaborales.find((item, index) => {
            return getEntornoOptionValue(item, index) === selectedEntornoLaboralId;
        });

        if (entornoSeleccionado) {
            setEntornoLaboralValues(entornoSeleccionado, dataUser);
        }
    }, [entornosLaborales, selectedEntornoLaboralId, dataUser]);

    useEffect(() => {
        if (selectedEntornoEsAutonomo === true) {
            clearCausaPagoValues();
        }
    }, [selectedEntornoEsAutonomo, clearCausaPagoValues]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const parseNumberOrNull = (value: any) => {
            if (value === null || value === undefined || value === "") return null;
            const parsed = Number(value);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const userId = dataUser?.UsuarioId?.toString() || null;
        const entornoLaboralIdValue = getValue(
            data?.EntornoLaboral?.EntornoLaboralId,
            selectedEntornoLaboralId,
            dataUser?.EntornoLaboralId,
            null
        );

        const documentacion = await prepareDocumentacionArrayWithCase(
            data?.Documentacion ?? data?.SeccionesDocumentacion ?? []
        );
        const isAutonomo = selectedEntornoEsAutonomo === true;

        const datosEnvio = {
            id: dataUser?.Id ?? null,
            expedienteId: parseNumberOrNull(dataUser?.ExpedienteId),
            prestacionId: prestacionId || null,
            entornoLaboralId: parseNumberOrNull(entornoLaboralIdValue),
            usuarioId: userId,
            personaId: parseNumberOrNull(dataUser?.PersonaId),
            acepto: data?.Acepto ?? false,
            impersonadorId: parseNumberOrNull(dataUser?.ImpersonadorId) ?? 0,
            datosPersonales: {
                nombre: data?.DatosPersonales?.SolicitanteNombre || null,
                apellido1: data?.DatosPersonales?.SolicitanteApellido1 || null,
                apellido2: data?.DatosPersonales?.SolicitanteApellido2 || null,
                ipf: data?.DatosPersonales?.SolicitanteIPF || null,
                ipfTipo: parseNumberOrNull(data?.DatosPersonales?.SolicitanteIPFTipo),
                telefono: data?.DatosPersonales?.SolicitanteTelefono || null,
                fijo: data?.DatosPersonales?.SolicitanteFijo || null,
                domicilio: data?.DatosPersonales?.SolicitanteDomicilio || null,
                codigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || null,
                provinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                codigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,
                codigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                localidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,
                numeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || null,
            },
            fechaNacimiento: data?.DatosPersonales?.SolicitanteFechaNacimiento || null,
            email: data?.DatosPersonales?.SolicitanteEmail || null,
            razonSocial: data?.EntornoLaboral?.PrestacionRazonSocial || null,
            ccc: data?.EntornoLaboral?.PrestacionCCC || null,
            naf: data?.EntornoLaboral?.PrestacionNAF || null,
            cif: data?.EntornoLaboral?.PrestacionCIF || null,
            codigoTipoContrato: data?.EntornoLaboral?.TipoContrato || null,
            tipoContratoDescripcion: data?.EntornoLaboral?.TipoContratoDescripcion || null,
            esAutonomo: selectedEntornoEsAutonomo,
            codigoRegimenSeguridadSocial: data?.EntornoLaboral?.RegimenSeguridadSocial || null,
            regimenSeguridadSocialDescripcion: data?.EntornoLaboral?.RegimenSeguridadSocialDescripcion || null,
            tipoIRPFVoluntario: parseNumberOrNull(data?.DatosPersonales?.IRPFVoluntario),
            fechaBajaMedica: data?.CausaPagoDirecto?.PrestacionFechaBajaMedica || null,
            codigoContingencia: data?.CausaPagoDirecto?.ContingenciaCodigo || null,
            contingenciaDescripcion: data?.CausaPagoDirecto?.ContingenciaCodigoDescripcion || null,
            codigoCausaPagoDirecto: isAutonomo ? null : (data?.CausaPagoDirecto?.CausaPago || null),
            causaPagoDirectoDescripcion: isAutonomo ? null : (data?.CausaPagoDirecto?.CausaPagoDescripcion || null),
            iban: data?.DatosBancarios?.SolicitanteIBAN?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || null,
            documentacion,
        }

        if (info) {
            createSolicitudPagoDirecto(userId, datosEnvio, _onSuccess);
            setBloquearEnvio(true);

        } else {
            updateSolicitudPagoDirectoById(userId, dataUser?.Id, datosEnvio, _onSuccess);
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={getValue(datosAPI?.EstadoFormulario, datosAPI?.estadoFormulario, dataUser?.EstadoFormulario, dataUser?.estadoFormulario)}
                    estadoFormularioDescripcion={getValue(datosAPI?.EstadoFormularioDescripcion, datosAPI?.estadoFormularioDescripcion, dataUser?.EstadoFormularioDescripcion, dataUser?.estadoFormularioDescripcion)}
                    fechaActualizacionEstado={getValue(datosAPI?.FechaActualizacionEstado, datosAPI?.fechaActualizacionEstado, dataUser?.FechaActualizacionEstado, dataUser?.fechaActualizacionEstado)}
                />

                <Loader activeLoader={loader || loadingCreateSolicitudPagoDirecto || loadingUpdateSolicitudPagoDirectoById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}

                <FormDatosPersonales activarSS={true} emailVisible={true} activarFechaNacimiento={true} />

                {/* ////////////// ENTORNOS LABORALES ////////////// */}
                <AccordionForm title={'Entornos Laborales'} expandedInit={false} nombreError='EntornoLaboral' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            {entornosLaborales.length > 1 && (
                                <div className="input-block mb-3">
                                    <label htmlFor="EntornoLaboralSelector" className="input-block__label">Entorno laboral</label>
                                    <select
                                        id="EntornoLaboralSelector"
                                        className="form-select"
                                        value={selectedEntornoLaboralId ?? ""}
                                        onChange={handleEntornoLaboralChange}
                                    >
                                        <option value="">Seleccione un entorno laboral</option>
                                        {entornosLaborales.map((entorno, index) => (
                                            <option
                                                key={getEntornoOptionValue(entorno, index)}
                                                value={getEntornoOptionValue(entorno, index)}
                                            >
                                                {getValue(entorno?.RazonSocial, entorno?.PrestacionRazonSocial, entorno?.Nombre, `Entorno laboral ${index + 1}`)}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="hidden"
                                        {...register('EntornoLaboral.EntornoLaboralId', {
                                            validate: (value) => {
                                                if (entornosLaborales.length <= 1) {
                                                    return true;
                                                }
                                                return (value !== null && value !== undefined && String(value).trim() !== "") || "Debe seleccionar un entorno laboral";
                                            }
                                        })}
                                    />
                                    {(errors as any)?.EntornoLaboral?.EntornoLaboralId?.message && (
                                        <p className="error m-0">{(errors as any).EntornoLaboral.EntornoLaboralId.message as string}</p>
                                    )}
                                </div>
                            )}
                            <FieldsetContainer legend="Entornos Laborales" disabled={false}>
                                <FormInputText
                                    name='EntornoLaboral.PrestacionRazonSocial'
                                    id='EntornoLaboral.PrestacionRazonSocial'
                                    label='Nombre o razón social de la empresa'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                />
                                <FormInputText
                                    name='EntornoLaboral.PrestacionCCC'
                                    id='EntornoLaboral.PrestacionCCC'
                                    label='Código Cuenta Cotización de la empresa'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    maxLength={11}
                                    invisible={selectedEntornoEsAutonomo !== false}
                                />
                                <FormInputText
                                    name='EntornoLaboral.PrestacionCIF'
                                    id='EntornoLaboral.PrestacionCIF'
                                    label='CIF de la empresa'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    invisible={selectedEntornoEsAutonomo !== true}
                                />
                                <FormInputText
                                    name='EntornoLaboral.PrestacionNAF'
                                    id='EntornoLaboral.PrestacionNAF'
                                    label='Número de Afiliación a la Seguridad Social (NAF)'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    invisible={selectedEntornoEsAutonomo !== true}
                                />
                                <FormInputText
                                    name='EntornoLaboral.TipoContrato'
                                    id='EntornoLaboral.TipoContrato'
                                    label='Tipo de contrato (ID)'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    invisible={true}
                                />
                                <FormInputText
                                    name='EntornoLaboral.TipoContratoDescripcion'
                                    id='EntornoLaboral.TipoContratoDescripcion'
                                    label='Tipo de contrato'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    invisible={selectedEntornoEsAutonomo === true}
                                />
                                <FormInputText
                                    name='EntornoLaboral.RegimenSeguridadSocial'
                                    id='EntornoLaboral.RegimenSeguridadSocial'
                                    label='Régimen Seguridad Social (ID)'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    invisible={true}
                                />
                                <FormInputText
                                    name='EntornoLaboral.RegimenSeguridadSocialDescripcion'
                                    id='EntornoLaboral.RegimenSeguridadSocialDescripcion'
                                    label='Régimen Seguridad Social'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                />
                                <FormInputText
                                    name='DatosPersonales.IRPFVoluntario'
                                    id='DatosPersonales.IRPFVoluntario'
                                    label='Tipo IRPF Voluntario (%)'
                                    md={12}
                                    xl={12}
                                    modal={'SOLIMAT procederá a aplicar el mínimo legal exigible, que es un 2%'}
                                    maxLength={5}
                                    placeholder='00,00'
                                    pattern={/^\d{1,5}([.,]\d{1,2})?$/}
                                    patternMessage='Solo se aceptan valores numéricos y decimales'
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                {/* ////////////// CAUSA DEL PAGO DIRECTO ////////////// */}
                <AccordionForm title={'Causa del Pago Directo'} expandedInit={false} nombreError='CausaPagoDirecto' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Causa del Pago Directo" disabled={false}>
                                <FormInputFecha
                                    name="CausaPagoDirecto.PrestacionFechaBajaMedica"
                                    id="CausaPagoDirecto.PrestacionFechaBajaMedica"
                                    label={'Fecha de Baja Médica'}
                                    placeholder={''}
                                    md={12}
                                    xl={12}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={true}
                                />
                                <FormInputText
                                    name='CausaPagoDirecto.ContingenciaCodigo'
                                    id='CausaPagoDirecto.ContingenciaCodigo'
                                    label='Contingencia (ID)'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                    invisible={true}
                                />
                                <FormInputText
                                    name='CausaPagoDirecto.ContingenciaCodigoDescripcion'
                                    id='CausaPagoDirecto.ContingenciaCodigoDescripcion'
                                    label='Contingencia'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                />
                                {selectedEntornoEsAutonomo !== true && (
                                    <InputCausaDelPago
                                        name='CausaPagoDirecto.CausaPago'
                                        contingenciaCodigo={contingenciaCodigo}
                                        md={12}
                                        xl={12}
                                        col={12}
                                        required='La Causa del Pago Directo es Obligatoria'
                                    />
                                )}
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                {/* ////////////// DATOS BANCARIOS ////////////// */}
                <AccordionForm title={'Datos Bancarios'} expandedInit={false} nombreError='DatosBancarios' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormInputCuentaBancaria
                                id='DatosBancarios.SolicitanteIBAN'
                                name='DatosBancarios.SolicitanteIBAN'
                                xl={12}
                                md={12}
                                placeholder=''
                                req='Falta el Número de Cuenta Bancaria'
                            />

                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Archivos a adjuntar'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormArrayArchivosReducidos
                                name={'Documentacion'}
                                setTotalSize={setTotalSize}
                            />

                        </div>
                    </div>
                </AccordionForm>

                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateSolicitudPagoDirecto}
                    successUpdate={successUpdateSolicitudPagoDirectoById}
                    errorCreate={errorCreateSolicitudPagoDirecto}
                    errorUpdate={errorUpdateSolicitudPagoDirectoById}
                    datosAPI={datosAPI}
                    info={info}
                    MaxSizeMB={MAX_SIZE_MB}
                    totalSizeDocs={totalSize}
                    label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, a día de la fecha, los datos declarados siguen siendo vigentes. Así mismo, quedo enterado de la obligación de comunicar a la Mutua cualquier variación de los datos en ella expresados que pudieran producirse durante la percepción de la prestación.'
                />


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default SolicitudPagoDirecto
